/*jshint esversion: 6 */

import Vue from 'vue';
import Vuex from 'vuex';


import user from './modules/user';
import logs from './modules/logs';
import booking from './modules/booking'; 
import horse from './modules/horse'; 
import resource from './modules/resource'; 
import config from './modules/config';
Vue.use(Vuex);


const state = {
  version: '1.2.0',
  versionCode: '1.2.0',
  clock: '',
  addBookingDialog: false,
  dateSelected: '',
  maxDate: '',
  dateCurrent: '',
  hour: '',
  message: '',
  showAlert: false,
  showAlertApprove: false,
  showAlertBooking: false,
  showAlertAddHorse: false,  

  newVersion: false,
  showNavbar: false,
  showInstallOnIos: false,
  db: null
};

const mutations = {
  setDateSelected(state, dateSelected) {
    state.dateSelected = dateSelected;
  }, 
  setDateCurrent(state, dateCurrent ) {
    state.dateCurrent = dateCurrent;
  },    
  setMessage(state, message) {
    state.message = message;
  },
  setShowAlertApprove(state, flag) {
    state.showAlertApprove = flag;
  },
  setShowAlertBooking(state, flag) {
    state.showAlertBooking = flag;
  },
  setShowAlertAddHorse(state, flag) {
    state.showAlertAddHorse = flag;
  },
  setShowAlert(state, flag) {
    state.showAlert = flag;
  },
  setShowInstallOnIos(state, flag) {
    state.showInstallOnIos = flag;
  },

  setShowNavbar(state, flag) {
    state.showNavbar = flag;    
  },

  setAddBookingDialog(state, flag) {
    state.addBookingDialog = flag;    
  },
  setHour(state, hour) {
    state.hour = hour;    
  },
  setMaxDate(state, maxDate) {    
    state.maxDate = maxDate;
  },
  setClock(state, clock) {    
    state.clock = clock;
  }       
};
const getters = {
  addBookingDialog: state => {
    return state.addBookingDialog;
  },  
  message: state => {
    return state.message;
  },  
  showAlertApprove: state => {
    return state.showAlertApprove;
  },
  showAlertBooking: state => {
    return state.showAlertBooking;
  },
  showAlertAddHorse: state => {
    return state.showAlertAddHorse;
  },
  showAlert: state => {
    return state.showAlert;
  },
  showNavbar: state => {
    return state.showNavbar; 
  },
  dateSelected: state => {
    return state.dateSelected;
  },
  dateCurrent: state => {
    return state.dateCurrent;
  },  
  showInstallOnIos: state => {
    return state.showInstallOnIos ;
  },  
  hour: state => {
    return state.hour ;
  },  
  maxDate: state => {
    return state.maxDate ;
  },
  clock: state => {
    return state.clock ;
  },
  version: state => {
    return state.version ;
  },
  versionCode: state => {
    return state.versionCode ;
  }     
};

const actions = {
  setShowNavbar(context, flag) {     
    context.commit('setShowNavbar', flag);
  },  
  setDateSelected(context, dateSelected) {
    context.commit('setDateSelected', dateSelected);
  }, 
  setDateCurrent(context, dateCurrent) {
    context.commit('setDateCurrent', dateCurrent);
  },     
  setAddBookingDialog(context, flag) {
    context.commit('setAddBookingDialog', flag);
  },  
  setMessage(context, message) {
    //console.log('setMessage:' + message)
    context.commit('setMessage', message);
  },
  setShowAlertApprove(context, flag) {
    context.commit('setShowAlertApprove', flag);     
  },
  setShowAlertBooking(context, flag) {
    context.commit('setShowAlertBooking', flag);   
  },
  setShowAlertAddHorse(context, flag) {
    context.commit('setShowAlertAddHorse', flag);
  },
  setShowAlert(context, flag) {
    context.commit('setShowAlert', flag);
  },  
  setShowInstallOnIos(context, flag) {
    context.commit('setShowInstallOnIos', flag);
  },  
  setHour(context, hour) {
    context.commit('setHour', hour);
  },
  setMaxDate(context, maxDate) {
    context.commit('setMaxDate', maxDate);
  },
  setClock(context, clock) {
    context.commit('setClock', clock);
  } 
};



const store = new Vuex.Store({
  modules: {
    user,
    booking,
    horse,
    resource,
    config,
    logs
  },
  state,
  mutations,
  actions,
  getters
});

 

export default store ;